import {version} from './version';
import {Logger} from '../logger';
import {inject} from '../di';

export function importScript(sSrc: string, fOnload?: () => void, fOnerror?: () => void, strictCacheControl?: boolean) {
  return new Promise<void>((resolve, reject) => {
    const logger = inject(Logger);
    logger.debug(`[importScript] Loading js file: "${sSrc}"...`);

    const prefix = sSrc.includes('?') ? `&` : '?';
    const cacheControlSuffix = strictCacheControl ? `${prefix}c=${Date.now()}` : `${prefix}v=${version.v}`;
    sSrc = sSrc + cacheControlSuffix;

    $.cachedScript(sSrc)
      .done(() => {
        logger.debug(`[importScript] JS file was loaded successfully: "${sSrc}"`);
        resolve();
        if (fOnload && typeof fOnload === 'function') {
          fOnload();
        }
      })
      .fail((err) => {
        logger.critical(`[importScript] Unexpected error while loading JS file "${sSrc}"`, err);
        reject(err);
        if (fOnerror && typeof fOnerror === 'function') {
          fOnerror();
        }
      });
  });
}

// TODO: legacy, used in vendors files,
// can be removed after vendors refactoring
window.importScript = importScript;
